import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { getRequestDetailItemInfo } from '../../../../utilities/selectors';
import { TableTd, TableRow } from '../../General/Table';
import { FlexCol } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { __ } from 'react-i18n';

export interface Props {
  product: any;
  theme: any;
  hasBottomBorder?: boolean;
}

function ItemsTabRow({ product, theme, hasBottomBorder = false }: Props) {
  const { image, name, quantity, units } = getRequestDetailItemInfo(product);

  return (
    <>
      <ImageNameTableTd hasBottomBorder={hasBottomBorder}>
        <ImageWrapper>
          <Image alt={`Obrázok ku produktu ${name}`} src={image} />
        </ImageWrapper>
        <NameInputWrapper>
          <NameLink>
            <Name>{name}</Name>
          </NameLink>
        </NameInputWrapper>
      </ImageNameTableTd>

      <StyledTableTd hasBottomBorder={hasBottomBorder} align="right">
        <ItemCount align="right">{`${quantity} ${units}`}</ItemCount>
      </StyledTableTd>
    </>
  );
}

const StyledTableTd = styled(TableTd)<{ hasBottomBorder: boolean }>`
  padding: ${rem(16)} 0;
  margin-left: ${rem(8)};
  border-bottom: ${({ hasBottomBorder, theme }) =>
    hasBottomBorder ? theme.borders.primary : 'none'};

  ${({ theme }) => theme.mediab.m810`
        margin-left: 0;
    `}
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(16)};

  &:hover,
  &:focus {
    cursor: default;
  }
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  max-width: initial;
`;

const NameInputWrapper = styled(FlexCol)``;

const NameLink = styled(TextP)`
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  text-align: left;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(200)};
  transition: color 0.2s;

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `}
`;

const ItemCount = styled(TextP)<{ align: string }>`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  margin-left: ${rem(8)};
  font-weight: 300;
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
  text-align: ${props => (props.align ? props.align : 'center')} !important;
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const WithTheme: any = withTheme(ItemsTabRow);
export { WithTheme as ItemsTabRow, StyledTableRow };
